"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const consts_1 = require("../../consts");
const formatDollarAmount_1 = require("../../utils/formatDollarAmount");
const parseDollarAmount_1 = require("../../utils/parseDollarAmount");
const pricingCalc_1 = require("../../utils/pricingCalc");
const setElsContent_1 = require("../../utils/setElsContent");
const setupMoneyField_1 = require("../../utils/setupMoneyField");
const setupNumberField_1 = require("../../utils/setupNumberField");
const els_1 = require("./els");
function update() {
    var _a;
    const teamSize = parseFloat(els_1.TEAM_SIZE_INPUT_EL.value);
    const averageSalary = (0, parseDollarAmount_1.parseDollarAmount)(els_1.AVERAGE_SALARY_INPUT_EL.value);
    if (!teamSize || !averageSalary || isNaN(teamSize) || isNaN(averageSalary))
        return;
    const costPerMonth = (((_a = consts_1.EDITION_PRICES_PER_SEAT["Business"]) === null || _a === void 0 ? void 0 : _a.annual) || 0) * teamSize;
    const { hoursSavedPerMonth, moneySavedPerMonth, totalROIPerMonth } = (0, pricingCalc_1.reclaimROICalculator)(teamSize, averageSalary, costPerMonth);
    els_1.HOURS_SAVED_PER_MONTH_EL.textContent = `${Math.round(hoursSavedPerMonth)}`;
    els_1.MONEY_SAVED_PER_MONTH_EL.textContent = (0, formatDollarAmount_1.formatDollarAmount)(moneySavedPerMonth);
    els_1.RECLAIM_COST_PER_MONTH_EL.textContent = (0, formatDollarAmount_1.formatDollarAmount)(costPerMonth);
    (0, setElsContent_1.setElsContent)(els_1.TOTAL_ELS, (0, formatDollarAmount_1.formatDollarAmount)(totalROIPerMonth));
}
(0, setupNumberField_1.setupNumberField)(els_1.TEAM_SIZE_INPUT_EL, update, { defaultValue: 10, min: 1 });
(0, setupMoneyField_1.setupMoneyField)(els_1.AVERAGE_SALARY_INPUT_EL, update, {
    defaultValue: 85000,
    noCents: true,
    min: 850,
});
update();
